import React from 'react';
import { styled } from '@mui/material/styles';
import {
    BudgetProposalT,
    BudgetProposalSettingsT,
} from 'routes/BudgetModule/config/types';
import 'routes/BudgetModule/components/BudgetProposal/shared/Grids/_commonGrid.scss';
import Loading from 'components/Loading';
import { useGetIntegrations } from 'helpers/integrations';
import { AutocompletAble } from 'ui/DropdownItems/types';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import ArbitrageChartSection from './components/ArbitrageChartSection';
import { useGetCustomFilters } from '../../hooks/budgetProposal';
import { useGetCadrageData } from '../../../helpers/hooks/getCadrageData';
import { ExpenseIncomeImputationDataT } from '../hooks/expenseIncomeImputations';
import { BudgetExpenseOrIncome } from 'business/constants';

type Props = {
    budgetProposal: BudgetProposalT;
    inscriptionsData: InscriptionT[];
    imputationsData: ExpenseIncomeImputationDataT[];
    resourceSoftwareId: string;
    settings: BudgetProposalSettingsT | undefined;
    onSettingsEdit: (arg1: Partial<BudgetProposalSettingsT>) => void;
    expenseOrIncome: BudgetExpenseOrIncome;
    hasOrphanInscriptions: boolean;
};

const StyContainer = styled('div', {
    name: 'StyContainer',
})(() => ({
    width: '100%',
    backgroundColor: 'white',
}));

function Cadrage({
    budgetProposal,
    inscriptionsData,
    imputationsData,
    resourceSoftwareId,
    settings,
    onSettingsEdit,
    expenseOrIncome,
    hasOrphanInscriptions,
}: Props): React.ReactElement {
    const { data: integrations } = useGetIntegrations();
    const { code, setCodes, codeOptions } = useGetCustomFilters(integrations);

    const { data: cadrageData, isFetching: isCadrageLoading } =
        useGetCadrageData(budgetProposal, code?.value);

    if (!cadrageData || isCadrageLoading) {
        return <Loading />;
    }

    const setCodesAndTrack = (codes: AutocompletAble<string> | null) => {
        trackEventBudget(
            TRACKABLE_EVENTS.budget.budgetProposal.expenseIncome
                .filterBudgetLineCode,
            {
                code: codes?.label,
            },
        );
        setCodes(codes);
    };

    return (
        <StyContainer>
            <ArbitrageChartSection
                budgetProposal={budgetProposal}
                inscriptionsData={inscriptionsData}
                imputationsData={imputationsData}
                cadrageData={cadrageData}
                settings={settings}
                onSettingsEdit={onSettingsEdit}
                code={code}
                setCodes={setCodesAndTrack}
                codeOptions={codeOptions}
                expenseOrIncome={expenseOrIncome}
                hasOrphanInscriptions={hasOrphanInscriptions}
                resourceSoftwareId={resourceSoftwareId}
            />
        </StyContainer>
    );
}

export default React.memo(Cadrage);
